import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { SOSListing } from './Pages';

export const SOSRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={SOSListing} />
        
    </Fragment>
)